module.exports = __webpack_public_path__ + "img/gift-bg.ccaf778c.png";